import React from 'react';
import {ModalMain} from 'damco-components';
import { ErrorTable } from './ErrorTable';
import { parseJsonBlob } from 'utilities/util';
interface ExceptionManagementProps {
    data: any;
    cols:any[];
    calculateAging:boolean;
    pageCount: number;
    file:any;
    hasUpdateAction?:boolean;
    tableName?: string;
    handleDownload?: (data:any)=>void;
    handleUpdate?: (data:any)=>void
    fetchData: (data:any)=>void
    linkAction: (data:any)=>void
    sendReprocess(id:string): void;
    toggleReprocess(id:string): void;
}
interface IState{
    showDialog:boolean,
    messageDetails: string,
    modalTitle: string
}
export class ExceptionManagement extends React.Component<ExceptionManagementProps, IState>{
    public dataTable = React.createRef<any>();
    public state = {
        showDialog: false,
        messageDetails: '',
        modalTitle: 'Error details'
    }
    public componentDidUpdate(props:any) {
        if(this.props.file && this.props.file !== props.file){
            this.setState({
                showDialog: true,
                messageDetails: parseJsonBlob(this.props.file),
                modalTitle: 'Error details'
            })
        }
    }
    public handleDetails = (data:any, title?: string) =>{
        const parseError = ()=>{
            const d = JSON.parse(JSON.stringify(data))
            let resp:any='';
            d.forEach((child:any)=> {
                resp += `${child} \n`
            })
            return resp
        }
        this.setState({
            showDialog: true,
            messageDetails: data && data.length>0? parseError(): 'No Data Available',
            modalTitle: title || 'Error details'
        })
    }
    public render(){
        return (
            <div>
                <ModalMain
                    modal={this.state.showDialog}
                    title={this.props.tableName === 'exception-management-file-download' ? 'Download Summary' : this.state.modalTitle}
                    hideMethod={() => this.setState({showDialog: false})} 
                    secondaryMethod={() => this.setState({showDialog: false})} 
                    primaryMethod={() => this.setState({showDialog: false})} 
                    btnTitle1={'OK'} 
                    btnTitle2={'Cancel'}>
                    <pre>{this.state.showDialog? this.state.messageDetails:''}</pre>
                </ModalMain>
                <ErrorTable
                    data={this.props.data}
                    cols={this.props.cols}
                    hasUpdateAction={this.props.hasUpdateAction}
                    handleUpdate={this.props.handleUpdate}
                    handleDownload={this.props.handleDownload}
                    calculateAging={this.props.calculateAging}
                    fetchData={this.props.fetchData}
                    pageCount={this.props.pageCount}
                    sendReprocess={this.props.sendReprocess}
                    toggleReprocess={this.props.toggleReprocess}
                    linkAction={this.props.linkAction}
                    handleDetails={this.handleDetails}
                    tableName={this.props.tableName}
                />
            </div>
        );
    }
}